const usLangSale = {
  'sale.helmet': 'Sell',
  'sale.code': 'Code',
  'sale.gift': 'Present',
  'sale.cash': 'Cash',
  'sale.number': 'Value',
  'sale.percent': 'Exchange',
  'sale.maximum': 'Minimize',
  'sale.description': 'Describe',
  'sale.duplicate': 'Shared voucher',
  'sale.name': 'Name',
  'sale.btn-unselect-discount': 'Uncheck the discount code',
  'sale.discount-placeholder': 'Select the discount code',
  'sale.discount-empty-title': 'No discount/gift code is currently available.',
  'sale.create-order-success': 'Create successful orders!',
  'sale.update-order-success': 'Update successful orders!',
  'sale.update-order-error': 'Update failure orders!',
  'sale.create-order-failure': 'Create unsuccessful orders! Please try again later.',
  'sale.create-order-loading': 'Conducting order ...',
  'sale.header.search-input.placeholder-1': 'Find goods',
  'sale.header.search-input.placeholder-2': 'Find sample prescriptions',
  'sale.header.type.search-sale': 'Sale',
  'sale.header.type.search-gift': 'Gift',
  'sale.header.order-tab-name': 'Invoice',
  'sale.header.btn-delete-order-tab': 'Delete',
  'sale.header.btn-add-order-tab': 'Add',
  'sale.header.link.admin': 'Management page',
  'sale.header.link.kitchen': 'Kitchen page',
  'sale.header.link.logout': 'Log out',
  'sale.header.btn-add-product': 'Add new goods',
  'sale.footer.tab.sell-quickly': 'Fast sale',
  'sale.footer.tab.sell-casual': 'Inventory',
  'sale.footer.btn-tutorial': 'User manual',
  'sale.footer.btn-letter': 'Feedback',
  'sale.item.more-action.note': 'Note',
  'sale.item.more-action.detail': 'Product detail',
  'sale.item.note.placeholder': 'Note...',
  'sale.container.footer.note-placeholder': '✎ Note of order',
  'sale.container.footer.total-price-tmp': 'Total money',
  'sale.sell-casual-tab.btn-filter': 'Product filter',
  'sale.sell-casual-tab.btn-view-mode-list': 'List mode',
  'sale.sell-casual-tab.btn-view-mode-thumbnail': 'Image mode',
  'sale.sell-casual-tab.btn-payment': 'Pay',
  'sale.sell-casual-tab.btn-print': 'Print bill',

  'sale.sell-casual-tab.current-point': 'Current number of points',
  'sale.sell-casual-tab.use-point': 'Use accumulation points',
  'sale.sell-casual-tab.use-point-placeholder': 'Enter the score you want to use',

  'sale.sell-casual-tab.title-1': 'Saler',
  'sale.sell-casual-tab.title-2': 'Status order',
  'sale.sell-casual-tab.title-3': 'Order discounts',
  'sale.sell-casual-tab.title-4': 'Total money',
  'sale.sell-casual-tab.title-5': 'Guests need to pay',
  'sale.sell-casual-tab.title-6': 'Payment guests',
  'sale.sell-casual-tab.title-7': 'Excess payment of passengers',

  'sale.sell-casual-tab.payment-type.cash': 'Cash',
  'sale.sell-casual-tab.payment-type.bank': 'Transfer',
  'sale.sell-casual-tab.payment-type.COD': 'COD',
  'sale.sell-casual-tab.payment-type.card': 'Card',
  'sale.sell-casual-tab.add-account-bank-title': 'Add bank account',
  'sale.loading-customer-title': 'Searching...',
  'sale.search-customer-placeholder': 'Find customers',
  'sale.search-voucher-placeholder': 'Find voucher',
  'sale.btn-unselect-user': 'Uncheck customers',
  'sale.btn-add-user': 'Add new customers',
  'sale.select-discount': 'Select the discount code',
  'sale.modal.customer.create.title': 'Add new customers',
  'sale.modal.customer.detail.title': 'Customer information',
  'sale.modal.customer.update.title': 'Update customer information',
  'sale.modal.customer.error-length-max': 'Maximum $x character!',
  'sale.modal.customer.type.col': 'Customer type',
  'sale.modal.customer.name.col': 'Customer name',
  'sale.modal.customer.name.placeholder': 'Nguyen Van A',
  'sale.modal.customer.name.error-required': 'Please enter the customer name!',
  'sale.modal.customer.phone.col': 'Phone',
  'sale.modal.customer.phone.placeholder': '08xxxxxxxx',
  'sale.modal.customer.phone.error-required': 'Please enter the phone number!',
  'sale.modal.customer.phone.error-invalid': 'Invalid phone number!',
  'sale.modal.customer.phone.is-exist': 'The phone number has been registered!',
  'sale.modal.customer.email.col': 'Email',
  'sale.modal.customer.email.placeholder': 'email@example.com',
  'sale.modal.customer.email.error-invalid': 'Invalid email!',
  'sale.modal.customer.address.col': 'Address',
  'sale.modal.customer.address.placeholder': 'Ex: Hung Loi Ward, Cai Rang Dist, Can Tho City',
  'sale.modal.customer.birthday.col': 'Date of birth',
  'sale.modal.note.create-customer.success': 'Add new successful customers!',
  'sale.modal.note.create-customer.failure': 'More new customers are not successful! Please try again later.',
  'sale.modal.note.create-customer.phone.duplicate': 'The phone number has been registered',
  'sale.modal.note.create-customer.email.duplicate': 'The email has been registered.',
  'sale.modal.note.update-customer.success': 'Update customer information successfully!',
  'sale.modal.note.update-customer.failure': 'Update customer failure successfully! Please try again later.',
  'sale.modal.btn-create': 'More',
  'sale.modal.btn-update': 'Update',
  'sale.title-add-customer': 'Add new customers',
  'sale.modal.note.confirm.create-customer.title': 'Confirm more customers',
  'sale.modal.note.confirm.create-customer.description': 'You definitely want to add customers <strong>$x</strong>?',
  'sale.modal.note.confirm.update-customer.title': 'Confirm customer information update',
  'sale.modal.note.confirm.update-customer.description': 'You definitely want to update customer information <strong>$x</strong>?',
  'sale.modal.failure.title': 'An error occurred!',
  'sale.modal.failure.description': 'Please come back later, or click the <strong>Refresh</strong> button to try again.',
  'sale.modal.failure.btn': 'Refresh',
  'sale.btn.bill': 'Selling drugs by applications',
  'sale.modal.bill.title': 'Drug information',
  'sale.modal.billCode.label': 'Prescription code',
  'sale.modal.billCode.error-required': 'Please enter the prescription code!',
  'sale.modal.doctor.label': 'Doctor prescribed',
  'sale.modal.hospital.label': 'Examination facility',
  'sale.modal.name.label': 'Patient name',
  'sale.modal.age.label': 'Year old',
  'sale.modal.gender.label': 'Sex',
  'sale.modal.gender.male.label': 'nam',
  'sale.modal.gender.female.label': 'Female',
  'sale.modal.weight.label': 'Weight',
  'sale.modal.id_card.label': 'CCCD',
  'sale.modal.id_bhyt.label': 'Card BHYT',
  'sale.modal.address.label': 'Address',
  'sale.modal.phone.label': 'Contact phone',
  'sale.modal.note.label': 'Diagnostic',
  'sale.modal.bill.btn.back': 'Skip',
  'sale.modal.bill.btn.save': 'Finished',
  'sale.failure.title.missing-customer': 'Please choose customers for orders!',
  'sale.failure.description.missing-customer': 'For visitors, choose <strong>Guests</strong>.',
  'sale.failure.description.missing-bill-code': 'Please enter <strong>Prescription code</strong> with the application <strong>Selling drugs under the prescription</strong>.',
  'sale.dropdown.bill-code': 'Prescription code',
  'sale.dropdown.order-code': 'Code orders',
  'sale.dropdown.username-name': 'Client',
  'sale.dropdown.username-phone': 'Phone number',
  'sale.empty-bill-info': 'There has been no results for your search.',
  'sale.staff.btn-remove': 'Unselect',
  'sale.staff-empty-title': 'There is currently no staff on the same shift as you.',
  'sale.staff-loading-title': 'Loading the list of employees in the shift...',
  'sale.dropdown.item.name': 'Name',
  'sale.dropdown.item.phone': 'Phone',
  'sale.dropdown.item.email': 'Email',
  'sale.cart-item-total': 'Total',
  'sale.modal.detail-product': 'The detail information of product',
  'sale.modal.detail-product.code.label': 'Code',
  'sale.modal.detail-product.barcode.label': 'Barcode',
  'sale.modal.detail-product.name.label': 'Name',
  'sale.modal.detail-product.image.label': 'Image',
  'sale.modal.detail-product.source.label': 'Source',
  'sale.modal.detail-product.unit.label': 'Unit',
  'sale.modal.detail-product.desc.label': 'Description',
  'sale.modal.detail-product.price.label': 'Price',
  'sale.modal.note-product': 'The note information of product',
  'sale.screen-filter-product.title': 'Filter product',
  'sale.screen-filter-product.sub-title-category': 'Product Categories',
  'sale.screen-filter-product.all': 'All',
  'sale.screen-filter-product.btn-clear': 'Cancel',
  'sale.screen-filter-product.btn-back': 'Back',
  'sale.screen-filter-product.btn-accept': 'Filter',
  'sale.inventory': 'Quantity',
  'sale.inventory-empty': 'Empty',
  'sale.quantity': 'Quantity',
  'sale.modal.work-places.title': 'Choose work place',
  'sale.modal.error-msg-work-place-require': 'Work place is required!',
  'sale.modal.work-places.btn-submit': 'Continue',
  'sale.barcode-scanner': 'Barcode scanner',
  'sale.barcode-scanner-request': 'Scan Barcode to apply voucher',
  'sale.minimum-order': 'Minimum order',
  'sale.reduce': 'Reduce',
  'sale.out-date': 'Out date',
  'sale.applying': 'Applying',
  'sale.render-qr-code.title': 'Banking information',
  'sale.my-voucher': 'My voucher',
  'sale.your-voucher-customer-choose': 'Voucher choose by customer',
  'sale.fnb.notify-content': '<i class="simple-icon-bell"></i> Bạn vừa cập nhật đơn hàng. Bấm nút <span>Thông báo</span> để gửi thông tin chế biến đến bar bếp.',
  'sale.fnb.notify-content-2': '<i class="simple-icon-bell"></i> Đơn hàng chờ xử lý.',

  'sale.fnb.modal-payment-table.btn.done': 'Payment',
  'sale.fnb.modal-send-require-payment-table.btn.done': 'Send required payment',
  'sale.fnb.create.request.payment.success': 'Send required payment success',
  'sale.fnb.create.request.payment.failure': 'Send required payment failure',
  'sale.fnb.notify.request-to-order': 'Table request order',
  'sale.fnb.notify.request-payment-to-order': 'Table request payment',
  'sale.fnb.notify-success': 'Kitchen has received notifications',
  'sale.fnb.form-payment.btn.note': 'Note',
  'sale.fnb.form-payment.btn.vat': 'Add VAT',
  'sale.fnb.form-payment.btn.qr-code': 'QR Code',
  'sale.fnb.form-payment.btn.decoupling': 'Decoupling',
  'sale.fnb.form-payment.btn.destroy': 'Cancel order',
  'sale.fnb.form-payment.btn.cancel-dish': 'Cancel dish',
  'sale.fnb.form-payment.btn.total': 'Total',
  'sale.fnb-modal-cancel-order.title': 'Remove order',
  'sale.fnb-modal-cancel-order.content': 'Warning: This order will be removed forever and cannot be undo. Are you sure to remove it?',
  'sale.fnb-modal-cancel-order.confirm': 'Confirm',
  'sale.fnb-modal-cancel-order.cancel': 'Cancel',
  'sale.fnb.order-created': 'New Order',
  'sale.fnb.order.status-draft': 'Draft',
  'sale.fnb.order.status-paid': 'Paid',
  'sale.fnb.order.status-canceled': 'Canceled',
  'sale.fnb.order.status-printed': 'Printed',
  'sale.fnb.order.status-processed': 'Processed',
  'sale.fnb.order.status-completed': 'Completed',
  'sale.fnb.order.status-approved': 'Approved',
  'sale.fnb.order.status-approved-not-number-product': 'Await export warehouse',

  'sale.order.confirm-leave': 'Order information unsaved, confirm exit?',
  'sale.gift.label': 'Gift',
  'sale.fnb.order-take-away-name': 'Take away',

  'sale.order.confirm-order-change': 'Order information is not sync. Please send notification to request!',
  'sale.order.confirm-order-change-2': 'Order waiting for process!',
  'sale.order.confirm-select-table': 'Please select a table to pay!',
  'sale.order.detail.time': 'Time',
  'sale.order.detail.name': 'Name',
  'sale.order.detail.quantity': 'QTY',
  'sale.order.detail.price': 'Unit price',
  'sale.order.detail.total-price': 'Total',
  'sale.order.detail.total': 'Total price',

  'sale.order.step.confirm': 'Confirm',
  'sale.order.step.point-stack': 'Stack point',
  'sale.order.step.discount': 'Discount',
  'sale.order.step.payment': 'Pay',

  'sale.fnb.btn-request-payment': 'Payment request',
  'sale.fnb.btn-request-notify': 'Notify request',
  'sale.fnb.btn-confirm-payment': 'Confirm',
  'sale.fnb.order-payment-error': 'Payment failed!',
  'sale.fnb.order-payment-success': 'Payment success!',
  'sale.order.bayment.step-back': 'Back',
  //
  'sale.order.update.less.than.kitchen': 'The update was unsuccessful. The quantity updated must be greater than the quantity already sent to the kitchen.',
  'sale-placeholder-search-order-take-away': 'Search customer, number phone',
  'sale-title-take-away': 'Take away',
  'sale.fnb.cancel-order-success': 'Cancel order success!',
  'sale.noti.product.empty': 'The product is out of stock',
  'sale.barcode-scanner-product-on': 'Product scanner is on',
  'sale.barcode-scanner-product-off': 'The product scanner is off',
  'sale.barcode-scanner-user-on': 'User code scanner is on',
  'sale.barcode-scanner-user-off': 'User code scanner is off',
  'sale.barcode-scanner-voucher-on': 'Discount code scanner is on',
  'sale.barcode-scanner-voucher-off': 'Discount code scanner is off',

  'sale.barcode-scanner-on': 'Scanner is on',
  'sale.barcode-scanner-off': 'Scanner is off',
  'sale.noti.have.voucher': 'Had voucher',
  'sale.allowed': 'Allowed',
  'sale.not.allowed': 'Not allowed',
  'sale.sell-casual-tab.title-discount-product': 'Product discount',
  'sale.sell-casual-tab.title-discount-order': 'Order discount',
  'sale.sell-casual-card-item-number': 'Number',
  'sale.sell-casual-card-item-price': 'Price',
  'sale.sell-casual-card-item-wholesale-price': 'Wholesale price',
  'sale.sell-casual-card-item-promo-price': 'Promo price',
  'sale.sell-casual-card-item-discount': 'Discount',
  'sale.sell-casual-card-item-after-discount': 'After discount',
  'sale.sell-casual-card-item-total': 'Total',
  'sale.sell-casual-card-item-title-gift': 'Gift',
  'sale.input.search.code': 'Input code',
  'sale.not.approved.label': 'Chưa xác nhận',

  'sale.fnb.promo-sale-price': 'Promotional sale price',
  'sale.fnb.promo-gift-section-title': 'Promotions — gifts (eligible)',
  'sale.fnb.promo-gift-suppressed-hint': 'Promo price edited — gift not applied for this line',
  'sale.retail.gift-min-condition': 'buy at least {min} items to receive the gift',
  'sale.retail.status.new': 'New',
  'sale.retail.status.printed': 'Printed',
  'sale.retail.gift.show': 'View gift',
  'sale.retail.gift.hide': 'Hide gift',
  'sale.wholesale.type.agency': 'Wholesale',
  'sale.wholesale.type.retail': 'Retail',
  'sale.wholesale.modal.title.remove': 'Remove wholesale mode',
  'sale.wholesale.modal.title.add': 'Convert to wholesale',
  'sale.wholesale.modal.content.remove': 'Are you sure you want to convert "{name}" to regular retail customer?',
  'sale.wholesale.modal.content.add': 'Are you sure you want to convert "{name}" to wholesale customer? Prices will be calculated at wholesale prices.',
  'sale.customer.type.label': 'Customer Target',
};

export default usLangSale;
